import { RelatedEventItem } from '../types/api';

function formatMinutes(minutes: number): string {
  const absolute = Math.abs(minutes);
  if (absolute < 60) return `${absolute} min`;
  const hours = Math.round((absolute / 60) * 10) / 10;
  return `${hours} hr`;
}

/** Turns the backend's relation fields into a short human label. */
export function relationLabel(item: RelatedEventItem): string | null {
  if (item.dayOffset === -1) return 'Day before';
  if (item.dayOffset === 1) return 'Day after';

  switch (item.timeRelation) {
    case 'SAME_TIME':
      return 'Same time';
    case 'OVERLAPS':
      return 'Overlaps';
    case 'SAME_DAY':
      return 'Same day';
    case 'ONGOING':
      return 'Ongoing';
    case 'BEFORE':
      return item.startOffsetMinutes != null
        ? `${formatMinutes(item.startOffsetMinutes)} earlier`
        : 'Earlier that day';
    case 'AFTER':
      return item.startOffsetMinutes != null
        ? `${formatMinutes(item.startOffsetMinutes)} later`
        : 'Later that day';
    default:
      return null;
  }
}

/** Venue name when known, otherwise the broadest place label available. */
export function locationLabel(item: RelatedEventItem): string | null {
  if (item.venueName) return item.venueName;
  const parts = [item.city, item.state].filter(Boolean);
  if (parts.length > 0) return parts.join(', ');
  return item.country || null;
}

/** Stable analytics dimension mirroring how the relation is labelled in the UI. */
export function relationKey(item: RelatedEventItem): string {
  if (item.dayOffset === -1) return 'DAY_BEFORE';
  if (item.dayOffset === 1) return 'DAY_AFTER';
  return item.timeRelation ?? 'NONE';
}
